// extracted by mini-css-extract-plugin
export default {"PlantsLists":"plantsLists-table_PlantsLists__vEP2J","sortIcons":"plantsLists-table_sortIcons__6EFJ7"};